import { render } from "./MonetaryInput.vue?vue&type=template&id=e24234d4&scoped=true"
import script from "./MonetaryInput.vue?vue&type=script&lang=js"
export * from "./MonetaryInput.vue?vue&type=script&lang=js"

import "./MonetaryInput.vue?vue&type=style&index=0&id=e24234d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24234d4"]])

export default __exports__